module.exports = __webpack_public_path__ + "front/img/p3.58a08cd1.jpg";